import { render } from "./ImageFilePreview.vue?vue&type=template&id=627edcdc&scoped=true"
import script from "./ImageFilePreview.vue?vue&type=script&lang=js"
export * from "./ImageFilePreview.vue?vue&type=script&lang=js"

import "./ImageFilePreview.vue?vue&type=style&index=0&id=627edcdc&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627edcdc"]])

export default __exports__